import { render, staticRenderFns } from "./page_loading.vue?vue&type=template&id=c8f1de38&scoped=true&"
import script from "./page_loading.vue?vue&type=script&lang=js&"
export * from "./page_loading.vue?vue&type=script&lang=js&"
import style0 from "./page_loading.vue?vue&type=style&index=0&id=c8f1de38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f1de38",
  null
  
)

export default component.exports